package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class ConfirmKeyUseCase(private val repo: TicketsRepository) {
    suspend operator fun invoke(ticketId: String, key: String) {
        repo.confirmKey(ticketId = ticketId, key = key)
    }
}
